import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { GradeLevelService } from "../report-services/grade-level.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { ReportService } from "../report.service";

@Component({
	selector: "app-student-old-photos",
	templateUrl: "./student-old-photos.component.html",
	styleUrls: ["./student-old-photos.component.css"],
})
export class StudentOldPhotosComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private gradelevelService: GradeLevelService,
		private dialogService: DialogService,
		private userService: UserService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		GradeLevelID: 0,
		OlderThanXDays: -1,
		SortByID: "PhotoAge",
		SortDirectionID: "DESC",
		ImageLogo: "",
	};

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	//Insert Custom Lists Here
	GradeLevelList: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	OlderThanCustomDays: number = 1;
	OlderThanList = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 365,
			Desc: "1 Year",
		},
		{
			ID: 730,
			Desc: "2 Years",
		},
		{
			ID: 1095,
			Desc: "3 Years",
		},
		{
			ID: 1460,
			Desc: "4 Years",
		},
		{
			ID: -2,
			Desc: "Custom",
		},
	];

	SortByList = [
		//Insert Custom List Items Here
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "PhotoAge",
			Desc: "Photo Age",
		},

		{
			ID: "SchoolName",
			Desc: "School Name",
		},
		{
			ID: "SchoolNumber",
			Desc: "School Number",
		},
		{
			ID: "Grade",
			Desc: "Grade Level",
		},
	];

	SortDirectionList = [
		//Insert Custom List Items Here
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
	];

	ReportID: number = 465;

	subscription: any;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadGradeLevelList();
		this.loadLogolist();
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length > 1) {
					// this.GradeLevelList.unshift({
					//     GradeLevelID: 0,
					//     GradeLevelDesc: "All GradeLevels"
					// })
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				} else {
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		// if (!this.report.SchoolID) {
		//     this.errorMessage = "Select the School";
		//     return
		// }

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var reportID = 465;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: GradeLevelID
		strParam += this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 2: OlderThanXDays
		if (this.report.OlderThanXDays == -2) {
			strParam += "," + this.OlderThanCustomDays + "|OlderThanXDays";
		} else {
			strParam += "," + this.report.OlderThanXDays + "|OlderThanXDays";
		}

		//Parameter 3: SortBy
		strParam += "," + this.report.SortByID + "|SortBy";

		//Parameter 4: SortDirection
		strParam += "," + this.report.SortDirectionID + "|SortDirection";

		//Parameter 5: UserID
		strParam += "," + this.user.userID + "|UserID";

		//Parameter 6: SchoolID
		strParam += "," + this.report.SchoolID + "|SchoolID";

		//Parameter 7: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
